/** 是否是🐈‍⬛黑猫服务商 */
export const isCatService = (code: string) => code === 'TCAT'
